import dayjs from 'dayjs'

/**
 * Generate an array of formatted months between two dayjs date objects.
 *
 * @param {dayjs.Dayjs} startDate - The start date.
 * @param {dayjs.Dayjs} endDate - The end date.
 * @return {string[]} An array of formatted months.
 */

type MonthDays = {
  month: string
  days: string[]
}

export function generateDatesArray(
  from: dayjs.Dayjs,
  to: dayjs.Dayjs
): MonthDays[] {
  const result: MonthDays[] = []

  let currentDate = from

  while (currentDate.isBefore(to) || currentDate.isSame(to, 'day')) {
    const currentMonthYear = currentDate.format('MM/YY')
    const endOfMonth = currentDate.endOf('month')
    const daysInThisMonth = []

    while (
      (currentDate.isBefore(endOfMonth) ||
        currentDate.isSame(endOfMonth, 'day')) &&
      (currentDate.isBefore(to) || currentDate.isSame(to, 'day'))
    ) {
      daysInThisMonth.push(currentDate.format('DD/MM/YYYY'))
      currentDate = currentDate.add(1, 'day')
    }

    result.push({
      month: currentMonthYear,
      days: daysInThisMonth,
    })
  }

  return result
}

type YearMonths = {
  year: string
  months: string[]
}

export function generateYearMonthsArray(
  from: dayjs.Dayjs,
  to: dayjs.Dayjs
): YearMonths[] {
  const result: YearMonths[] = []

  let currentDate = from

  while (currentDate.isBefore(to) || currentDate.isSame(to, 'day')) {
    const currentYear = currentDate.format('YYYY')
    const endOfYear = currentDate.endOf('year')
    const monthsInThisYear = []

    while (
      (currentDate.isBefore(endOfYear) ||
        currentDate.isSame(endOfYear, 'day')) &&
      (currentDate.isBefore(to) || currentDate.isSame(to, 'day'))
    ) {
      monthsInThisYear.push(currentDate.format('MM/YYYY'))
      currentDate = currentDate.add(1, 'month')
    }

    result.push({
      year: currentYear,
      months: monthsInThisYear,
    })
  }

  return result
}
